module.exports = __webpack_public_path__ + "img/Brazil.b346fdb0.png";